<template>
    <i :class="[$style['icon'], 'ueicon-' + name]"></i>
</template>
<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        size: {
            type: Number,
            default: undefined
        },
        color: {
            type: String,
            default: undefined
        }
    }
};
</script>
</script>
<style lang="scss" module>
.icon {
    font-family: "ueicon";
    font-style: normal;
    line-height: 1;
    display: flex;
    width: 1em;
    height: 1em;
    align-items: center;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    justify-content: center;
}
</style>
